import Modal from 'antd/es/modal/Modal';
import {
  $bizDistrictModalState,
  $bizPollsAnswerDetailsModal,
  $bizPollsStatsModalData,
  $bizPollsStatsModalState,
  $bizPollsStatsYearlyDetailsData,
  BizPollsStatsYearDetailsModalGate,
  getBizModalPollsStatsYearDetailsFx,
  resetBizPollsAnswerDetailsModalEv,
  resetBizPollsStatsModalEv,
  setBizPollsAnswerDetailsModalEv,
} from '../../../../models/overviewModel/index.js';
import { useStoreMap, useUnit } from 'effector-react';
import { Bar, Column, Pie } from '@ant-design/charts';
import {
  Button,
  Card,
  Col,
  Divider,
  Row,
  Skeleton,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import { $activitiesMap } from '../../../../models/globalModel/index.js';
import { useMemo, useState } from 'react';
import { RollbackOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import html2canvas from 'html2canvas';
import style from '../../Overview.module.css';
import { jsPDF } from 'jspdf';

export default function BizPollsStatsModal() {
  const { t } = useTranslation();

  const open = useUnit($bizPollsStatsModalState);
  const close = useUnit(resetBizPollsStatsModalEv);

  const { granularity } = useUnit($bizDistrictModalState);

  const takeScreen = () => {
    const element = document.getElementById('content');
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `${t('dashboard.business_climate.Детали опросов')}.png`;
      link.click();
    });
  };

  const generatePDF = () => {
    const element = document.getElementById('content');
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);

      const finalWidth = imgWidth * ratio;
      const finalHeight = imgHeight * ratio;

      const marginX = (pageWidth - finalWidth) / 2;
      const marginY = (pageHeight - finalHeight) / 2;

      pdf.addImage(imgData, 'PNG', marginX, marginY, finalWidth, finalHeight);
      pdf.save(`${t('dashboard.business_climate.Детали опросов')}.pdf`);
    });
  };

  return (
    <Modal
      title={t('dashboard.business_climate.Детали опросов')}
      open={open}
      width={'90dvw'}
      onCancel={() => close()}
      rootClassName={'bizPollsStatsModal'}
      footer={null}
      destroyOnClose
      styles={{
        header: { background: '#f3f6fe' },
        body: { background: '#f3f6fe' },
      }}
    >
      <Button onClick={takeScreen} className={style.screenshot_button}>
        Скриншот
      </Button>
      <Button onClick={generatePDF} className={style.pdf_button}>
        PDF
      </Button>
      {granularity === 'quarter' ? (
        <QuarterPollsModalContent />
      ) : (
        <YearPollsModalContent />
      )}
    </Modal>
  );
}

function QuarterPollsModalContent() {
  const okedMap = useUnit($activitiesMap);
  const { okedChart, okedDetailsChart, categoriesCharts, diagram } =
    useStoreMap($bizPollsStatsModalData, (data) => {
      return {
        okedChart: Object?.entries(data?.oked_counts ?? [])?.map(
          ([key, value]) => ({
            // oked: t(`dashboard.business_climate.${okedMap[key]}`),
            oked: okedMap[key],
            count: Object.values(value).reduce((a, b) => a + b, 0),
            id: key,
          })
        ),
        okedDetailsChart: Object.fromEntries(
          Object?.entries(data?.oked_counts ?? [])?.map(([key, value]) => [
            key,
            Object.entries(value)?.map(([key, count]) => ({
              oked: okedMap[key],
              count,
            })),
          ])
        ),
        categoriesCharts: Object?.entries(
          data?.category_percentages ?? []
        )?.map(([key, value]) => {
          return {
            header: key,
            chart: Object?.entries(value ?? {})?.map(([key, value]) => ({
              category: key,
              percent: value,
            })),
          };
        }),
        diagram: Object?.entries(data?.diagram ?? []).map(([key, value]) => ({
          type: key,
          value: Number(value.percent),
          count: value.count,
        })),
      };
    });

  const [selectedOked, setSelectedOked] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const { t } = useTranslation();

  const questionsCharts = useMemo(() => {
    return categoriesCharts?.map(({ header, chart }) => (
      <Col span={12}>
        <Card size={'small'} style={{ height: '100%' }}>
          <Typography.Paragraph style={{ textAlign: 'center' }}>
            <strong>{header}</strong>
          </Typography.Paragraph>
          <Bar
            data={chart}
            height={150}
            label={{ position: 'left' }}
            yAxis={{
              label: {
                formatter: (v) => (v.length > 17 ? `${v.slice(0, 17)}...` : v),
              },
            }}
            meta={{
              percent: {
                alias: 'Процент',
                formatter: (v) => `${Math.round(v)}%`,
              },
            }}
            tooltip={{
              formatter: ({ _, percent }) => {
                return { name: 'Показатель', value: `${Math.round(percent)}%` };
              },
            }}
            xField={'percent'}
            yField={'category'}
          />
        </Card>
      </Col>
    ));
  }, [categoriesCharts]);

  return (
    <div id={'content'}>
      <Card size={'small'}>
        {selectedTitle ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ width: '10%' }} />
            <Typography.Title
              level={5}
              style={{ textAlign: 'center', marginTop: 0 }}
            >
              {selectedTitle}
            </Typography.Title>
            <Tooltip title={'Назад'}>
              <RollbackOutlined
                style={{ fontSize: 24 }}
                onClick={() => {
                  setSelectedOked(null);
                  setSelectedTitle(null);
                }}
              />
            </Tooltip>
          </div>
        ) : (
          <Typography.Title
            level={5}
            style={{ textAlign: 'center', marginTop: 0 }}
          >
            {t('dashboard.business_climate.Отраслевая структура респондентов')}
          </Typography.Title>
        )}
        <Column
          data={selectedOked ? okedDetailsChart[selectedOked] : okedChart}
          seriesField={'oked'}
          legend={{ position: 'left' }}
          tooltip={{
            formatter: ({ _, count }) => {
              return {
                name: t('dashboard.business_climate.Количество ответов'),
                value: count,
              };
            },
          }}
          xAxis={{
            label: false,
          }}
          xField={'oked'}
          yField={'count'}
          onReady={(plot) => {
            plot.on('plot:click', (evt) => {
              const { x, y } = evt;
              setSelectedOked(
                plot?.chart?.getTooltipItems({ x, y })[0]?.data?.id ?? null
              );
              setSelectedTitle(
                plot?.chart?.getTooltipItems({ x, y })[0]?.data?.id
                  ? plot?.chart?.getTooltipItems({ x, y })[0]?.data.oked
                  : null
              );
            });
          }}
        />
      </Card>
      <Divider />
      <Row justify={'space-between'} gutter={[48, 24]}>
        {...questionsCharts}
      </Row>
      <Row gutter={[48, 24]} style={{ marginTop: 24 }}>
        <Col span={12}>
          <Card size={'small'} style={{ height: '100%' }}>
            <Typography.Paragraph style={{ textAlign: 'center' }}>
              <strong>
                Какие барьеры вы считаете наиболее высокими для получения мер
                государственной поддержки?
              </strong>
            </Typography.Paragraph>
            <Pie
              data={diagram}
              appendPadding={10}
              angleField={'value'}
              colorField={'type'}
              radius={0.8}
              label={{
                type: 'inner',
                offset: '-30%',
                content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
                style: {
                  textAlign: 'center',
                },
              }}
              tooltip={{
                formatter: (datum) => {
                  return {
                    name: datum.type,
                    value: datum.value + '%',
                  };
                },
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}

function YearPollsModalContent() {
  const loading = useUnit(getBizModalPollsStatsYearDetailsFx.pending);
  const { t } = useTranslation();
  const okedMap = useUnit($activitiesMap);

  const data = useUnit($bizPollsStatsYearlyDetailsData);

  const setDetailsModal = useUnit(setBizPollsAnswerDetailsModalEv);

  const [selectedOked, setSelectedOked] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);

  const { okedChart, okedDetailsChart } = useMemo(() => {
    return {
      okedChart: Object?.entries(data?.oked_counts ?? [])?.map(
        ([key, value]) => ({
          oked: okedMap[key],
          count: Object.values(value).reduce((a, b) => a + b, 0),
          id: key,
        })
      ),
      okedDetailsChart: Object.fromEntries(
        Object?.entries(data?.oked_counts ?? [])?.map(([key, value]) => [
          key,
          Object.entries(value)?.map(([key, count]) => ({
            oked: okedMap[key],
            count,
          })),
        ])
      ),
    };
  }, [data]);

  const questionsCharts = useMemo(() => {
    return data.charts?.map(({ label, chart_data }, idx) => (
      <Col span={24}>
        <Card size={'small'}>
          <Typography.Paragraph>
            <strong>
              {idx + 1}. {label}
            </strong>
          </Typography.Paragraph>
          <Bar
            data={chart_data}
            minBarWidth={18}
            maxBarWidth={18}
            padding={[20, 20, 20, 320]}
            color={'l(270) 0:#7A91FF 1:#3A4DE9'}
            barStyle={{
              radius: [20, 20, 0, 0],
            }}
            xAxis={{
              min: 0,
              max: 100,
              tickInterval: 25,
              label: {
                formatter: (v) => `${v}`,
                style: { fill: '#999' },
              },
              grid: {
                line: {
                  style: { stroke: '#eee' },
                },
              },
            }}
            yAxis={{
              label: {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  textAlign: 'start',
                },
                offset: 320,
                formatter: (text) => {
                  if (!text) return '';
                  const prep =
                    text.length > 65 ? text.slice(0, 65) + '...' : text;
                  return prep.replace(/(.{30}\s)/g, '$1\n');
                },
              },
            }}
            meta={{
              percentage: {
                alias: 'Процент',
                formatter: (v) => `${Math.round(v)}%`,
              },
            }}
            tooltip={{
              formatter: ({ _, percentage }) => {
                return {
                  name: 'Показатель',
                  value: `${Math.round(percentage)}%`,
                };
              },
            }}
            onReady={(plot) => {
              plot.on('plot:click', (evt) => {
                const { data } = evt;
                if (data?.data?.details && data?.data?.details.length > 0) {
                  setDetailsModal({
                    open: true,
                    question: `${idx + 1}. ${label}`,
                    answer: data.data.answer_option,
                    data: data.data.details,
                  });
                }
              });
            }}
            xField={'percentage'}
            yField={'answer_option'}
          />
        </Card>
      </Col>
    ));
  }, [data]);

  return (
    <>
      <BizPollsStatsYearDetailsModalGate />
      {loading ? (
        <Skeleton loading={true} />
      ) : (
        <div id={'content'}>
          <AnswerDetailsModal />
          <Space direction={'vertical'} style={{ width: '100%' }}>
            <Card size={'small'}>
              {selectedTitle ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                  }}
                >
                  <div style={{ width: '10%' }} />
                  <Typography.Title
                    level={5}
                    style={{ textAlign: 'center', marginTop: 0 }}
                  >
                    {selectedTitle}
                  </Typography.Title>
                  <Tooltip title={'Назад'}>
                    <RollbackOutlined
                      style={{ fontSize: 24 }}
                      onClick={() => {
                        setSelectedOked(null);
                        setSelectedTitle(null);
                      }}
                    />
                  </Tooltip>
                </div>
              ) : (
                <Typography.Title
                  level={5}
                  style={{ textAlign: 'center', marginTop: 0 }}
                >
                  {t(
                    'dashboard.business_climate.Отраслевая структура респондентов'
                  )}
                </Typography.Title>
              )}
              <Column
                data={selectedOked ? okedDetailsChart[selectedOked] : okedChart}
                seriesField={'oked'}
                legend={{ position: 'left' }}
                tooltip={{
                  formatter: ({ _, count }) => {
                    return {
                      name: t('dashboard.business_climate.Количество ответов'),
                      value: count,
                    };
                  },
                }}
                xAxis={{
                  label: false,
                }}
                xField={'oked'}
                yField={'count'}
                onReady={(plot) => {
                  plot.on('plot:click', (evt) => {
                    const { x, y } = evt;
                    setSelectedOked(
                      plot?.chart?.getTooltipItems({ x, y })[0]?.data?.id ??
                        null
                    );
                    setSelectedTitle(
                      plot?.chart?.getTooltipItems({ x, y })[0]?.data?.id
                        ? plot?.chart?.getTooltipItems({ x, y })[0]?.data.oked
                        : null
                    );
                  });
                }}
              />
            </Card>
            {...questionsCharts}
          </Space>
        </div>
      )}
    </>
  );
}

function AnswerDetailsModal() {
  const { open, question, answer, data } = useUnit($bizPollsAnswerDetailsModal);

  const reset = useUnit(resetBizPollsAnswerDetailsModalEv);

  const charts = useMemo(() => {
    return data.map((i) => (
      <Col span={24}>
        {i.agency ? (
          <Typography.Paragraph
            style={{ fontWeight: 700, fontSize: 13, color: '#505D6F' }}
          >
            {i.agency}
          </Typography.Paragraph>
        ) : null}
        <Bar
          data={i.data}
          minBarWidth={18}
          maxBarWidth={18}
          padding={[20, 20, 20, 320]}
          color={'l(270) 0:#7A91FF 1:#3A4DE9'}
          barStyle={{
            radius: [20, 20, 0, 0],
          }}
          xAxis={{
            min: 0,
            max: 100,
            tickInterval: 25,
            label: {
              formatter: (v) => `${v}`,
              style: { fill: '#999' },
            },
            grid: {
              line: {
                style: { stroke: '#eee' },
              },
            },
          }}
          yAxis={{
            label: {
              style: {
                fontSize: 13,
                fontWeight: 500,
                textAlign: 'start',
              },
              offset: 320,
              formatter: (text) => {
                if (!text) return '';
                const prep =
                  text.length > 65 ? text.slice(0, 65) + '...' : text;
                return prep.replace(/(.{30}\s)/g, '$1\n');
              },
            },
          }}
          meta={{
            percentage: {
              alias: 'Процент',
              formatter: (v) => `${Math.round(v)}%`,
            },
          }}
          tooltip={{
            formatter: ({ _, percentage }) => {
              return {
                name: 'Показатель',
                value: `${Math.round(percentage)}%`,
              };
            },
          }}
          xField={'percentage'}
          yField={'group'}
        />
      </Col>
    ));
  }, [data]);

  return (
    <Modal
      open={open}
      title={question}
      footer={null}
      onCancel={reset}
      width={'80dvw'}
      destroyOnClose={true}
    >
      <Typography.Paragraph
        style={{
          fontWeight: 600,
          fontSize: 15,
          marginBlock: 24,
          color: '#000000D9',
        }}
      >
        {answer}
      </Typography.Paragraph>
      {...charts}
    </Modal>
  );
}
